import styled from "styled-components";
import { colors, types } from "../../../../../libs";
import { Play } from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";

export const selectStyles = {
  menu: (baseStyles) => ({
    ...baseStyles,
    background: colors.background.formField,
    borderColor: "transparent",
    color: colors.text.white,

  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    background: state.isFocused ? "#ccc" : colors.background.formField,
    color: state.isSelected ? colors.text.white : state.isFocused ? colors.background.formField : colors.text.white,
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white,
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: "50px",
    background: colors.background.formField,
    color: colors.text.white,
    border: state.isFocused ? "1px solid transparent" : "1px solid transparent",
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.gray,
    fontSize: types.body.label,
  }),
};

export const FilePreviewCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.background.black};
  border: 1px solid  ${colors.background.disabled};
  padding: 10px;
  border-radius: 8px;
  margin-top: 0px; 
  margin-bottom: 24px; 
`;
export const DiscardSaveCard = styled.div`
  background-color:  ${colors.background.black};
  border: 1px solid  ${colors.background.disabled};
  padding: 10px;
  border-radius: 8px;
  margin-top: 0px; 
  margin-bottom: 10px; 
`;
export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const FileIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const FileDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; 
`;


export const FileType = styled.span`
   ${types.headers.small};
  color:  ${colors.text.green};
  white-space: nowrap;
  cursor: pointer;
`;

export const FileName = styled.span`
 cursor: pointer;
   ${types.body.label};
  color: ${colors.text.white}
  max-width: 100%; 
  word-break: break-word;
  overflow-wrap: anywhere;
`;
export const MidRol = styled.span`
 cursor: pointer;
`;

export const FileActions = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
`;

export const ActionIcon = styled.img`
  cursor: pointer;
  max-width:none;
  &:hover {
    opacity: 0.8;
  }
`;

export const DiscardSaveCardInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px; 
  width: 100%;
  padding-top: 8px;
`;

export const FileInfoContainer = styled.div`
  flex: 1; 
  display: flex;
  align-items: center;
`;

export const AddTypeSelectContainer = styled.div`
  flex: 1; 
`;

export const PlayIcon = styled(Play)`
  cursor: pointer;
  max-width:none;
  font-size: 32px;
  color: ${colors.text.green};
  &:hover {
    opacity: 0.8;
  }
`;

export const PlayerModalHeader = styled(Modal.Header)`
  background: ${colors.background.black};
  color: ${colors.text.mediumWhite};
`;

export const PlayerModalBody = styled(Modal.Body)`
  background: ${colors.background.black};
  padding: 30px 10px;
`;
